var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "in-activity-button",
    staticStyle: {
      "background": "transparent",
      "border": "0",
      "height": "75px",
      "width": "75px"
    },
    attrs: {
      "aria-label": "Continue",
      "tabindex": !_vm.removeTabIndex ? '11' : ''
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('forward-icon', {
    attrs: {
      "height": "75",
      "width": "75"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }